import {_} from 'lodash';
import * as ko from "knockout";
import {IRouteDefinitionParams} from "../../index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {nsRoute} from "../../util/route";
import {nsDom} from "../../util/dom";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import waitForElementId = nsDom.waitForElementId;
import destinationHtml from './destination.html?raw';

export let template = destinationHtml;

export class viewModel extends ParsedRouteDataDecorator {
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private el!: HTMLElement;
    private readonly isReady: KnockoutObservable<boolean> = ko.observable(false);
    /** Current tab (or dialog) — used for visible/if panel switching. */
    private readonly isActivePanel: KnockoutComputed<boolean>;
    /**
     * Shared content-wrapper forms (create/edit customer, …): keep panel DOM across tab switches.
     * tab-panels hosts one component per tab — destroy when hidden so heavy details tabs unload.
     */
    private readonly keepPanelAlive: boolean;

    constructor(params: IRouteDefinitionParams) {
        const tabManager = params.__tabManager;
        const routeId = params.__routeId;
        if (!tabManager || !routeId) {
            super(params);
        } else {
            super(_.defaults({__routeDef: tabManager.getDef(routeId)}, params));
        }
        this.keepPanelAlive = tabManager?.shouldKeepDestinationPanelsAlive() ?? false;
        this.isActivePanel = ko.pureComputed(() => {
            const visible = this.__tab?.isVisible() ?? false;
            const permissible = this.__tab?.isPermissible() ?? false;
            const current = this.__tab?.isCurrent() ?? false;
            const inDialog = !!this.__tabManager?.__dialog;
            return visible && permissible && (current || inDialog);
        });
        waitForElementId(this.__componentId)
            .then(() => {
                const el = document.getElementById(this.__componentId)
                if (el) {
                    this.el = el
                    this.isReady(true)
                }
            })
    }

    override dispose() {
        super.dispose();
        this.kosub.unsuscribeAll();
    }
}
